
import {Fragment} from 'vue-fragment'
import Vue from 'vue';
Vue.component('Fragment', Fragment );